import { render } from "./ServiceComponent.vue?vue&type=template&id=144684d8&scoped=true"
import script from "./ServiceComponent.vue?vue&type=script&lang=js"
export * from "./ServiceComponent.vue?vue&type=script&lang=js"

import "./ServiceComponent.vue?vue&type=style&index=0&id=144684d8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144684d8"]])

export default __exports__